import { styled } from 'styled-components';

import React from 'react';

const Div = styled.div`
    color: ${(props) => props.theme.colorPrimary};
    text-align: left;
    font-family: Poppins, serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
`;

const SubHeading = ({ children, className = '', style = {}, sx = {} }) => {
    return <Div className={className} style={{ ...style, ...sx }}>{children}</Div>;
};

export default SubHeading;
